module.exports = __webpack_public_path__ + "img/img2.0d4c9889.svg";